import { useDebugHydration, useForceHydration } from './context/selectors'

const green = {
  background: '#eeffee',
  '&>*': { background: '#eeffee !important' },
}
const red = {
  background: '#ffeeee',
  '&>*': { background: '#ffeeee !important' },
}

export const RedWrapper = props => {
  const debugHydration = useDebugHydration()
  return <span {...props} sx={debugHydration ? red : {}} />
}
export const GreenWrapper = props => {
  const debugHydration = useDebugHydration()
  return <span {...props} sx={debugHydration ? green : {}} />
}

const DontHydrate = props => {
  const isServer = typeof window === 'undefined'
  const debugHydration = useDebugHydration()
  const forceHydration = useForceHydration()

  return (
    <Choose>
      {/* Rendered on the server */}
      <When condition={isServer}>
        <span sx={debugHydration ? green : {}}>{props.children}</span>
      </When>

      {/* Hydrated in the browser */}
      <When condition={forceHydration}>
        <span sx={debugHydration ? red : {}}>{props.children}</span>
      </When>

      {/* NOT hydrated in the browser */}
      <Otherwise>
        <span
          className={props.className}
          dangerouslySetInnerHTML={{ __html: '' }}
          suppressHydrationWarning
        />
      </Otherwise>
    </Choose>
  )
}

export default DontHydrate
